import { Feature } from '@vi-iot/client';

/**
 * Verify if the feature has properties, is ready and enabled
 */
export function isReady<T>(feature: T): boolean {
  if (isOfTypeFeature(feature)) {
    return !!(feature && feature.properties && feature.isEnabled && feature.isReady);
  } else {
    return false;
  }
}

export function isOfTypeFeature(feature: any): feature is Feature<unknown, unknown> {
  const typedFeature = feature as Feature<unknown, unknown>;

  return (
    typedFeature?.properties !== undefined &&
    typedFeature?.isEnabled !== undefined &&
    typedFeature?.isReady !== undefined
  );
}
